import { Component, Input } from '@angular/core';
import { Item } from '../../../../../core/shared/item.model';
import { ItemPageDateFieldComponent } from './item-page-date-field.component';
import { ThemedComponent } from '../../../../../shared/theme-support/themed.component';
import { ItemPageAbstractFieldComponent } from '../abstract/item-page-abstract-field.component';

@Component({
    selector: 'ds-themed-item-page-date-field',
    styleUrls: [],
    templateUrl: '../../../../../shared/theme-support/themed.component.html',
})
/**
 * This component is used for displaying the issue date (dc.date.issued) metadata of an item
 */
export class ThemedItemPageDateFieldComponent extends ThemedComponent<ItemPageDateFieldComponent> {

  @Input() item: Item;

  protected inAndOutputNames: (keyof ItemPageAbstractFieldComponent & keyof this)[] = [
    'item',
  ];

  protected getComponentName(): string {
    return 'ItemPageDateFieldComponent';
  }

  protected importThemedComponent(themeName: string): Promise<any> {
    return import(`../../../../../../themes/${themeName}/app/item-page/simple/field-components/specific-field/date/item-page-date-field.component`);
  }

  protected importUnthemedComponent(): Promise<any> {
    return import(`./item-page-date-field.component`);
  }
}
